import { useMutation } from '@tanstack/react-query';
import { setRole } from '../services/auth_service';

export const useSetRole = () => {
    return useMutation({
        mutationFn: setRole,
        onSuccess: (data) => {
        },
        onError: (error) => {
            console.error('Failed to set role:', error);
        }
    });
};
